var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1256_82)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 6.46731C16.5164 6.17573 16.9912 6.17784 17.2828 6.47204C17.5744 6.76624 17.5723 7.24111 17.2781 7.53269L15.5151 9.28C14.7996 9.98914 14.3088 10.4772 13.9767 10.8907C13.6541 11.2924 13.5434 11.5504 13.514 11.7815C13.4955 11.9266 13.4955 12.0734 13.514 12.2185C13.5434 12.4496 13.6541 12.7076 13.9767 13.1093C14.3088 13.5228 14.7996 14.0109 15.5151 14.72L17.2781 16.4673C17.5723 16.7589 17.5744 17.2338 17.2828 17.528C16.9912 17.8222 16.5164 17.8243 16.2222 17.5327L14.4274 15.7539C13.7515 15.084 13.199 14.5364 12.8072 14.0485C12.3998 13.5412 12.1048 13.0263 12.026 12.4082C11.9915 12.1371 11.9915 11.8629 12.026 11.5918C12.1048 10.9737 12.3998 10.4588 12.8072 9.95146C13.199 9.46359 13.7515 8.91604 14.4274 8.24609L16.2222 6.46731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2222 6.46731C10.5164 6.17573 10.9912 6.17784 11.2828 6.47204C11.5744 6.76624 11.5723 7.24111 11.2781 7.53269L9.51511 9.28C8.79962 9.98914 8.30882 10.4772 7.97672 10.8907C7.65412 11.2924 7.54345 11.5504 7.51399 11.7815C7.4955 11.9266 7.4955 12.0734 7.51399 12.2185C7.54345 12.4496 7.65412 12.7076 7.97672 13.1093C8.30882 13.5228 8.79962 14.0109 9.51511 14.72L11.2781 16.4673C11.5723 16.7589 11.5744 17.2338 11.2828 17.528C10.9912 17.8222 10.5164 17.8243 10.2222 17.5327L8.42743 15.7539C7.75146 15.084 7.19898 14.5364 6.80718 14.0485C6.39975 13.5412 6.10482 13.0263 6.02603 12.4082C5.99149 12.1371 5.99149 11.8629 6.02603 11.5918C6.10482 10.9737 6.39975 10.4588 6.80718 9.95146C7.19899 9.46359 7.75146 8.91604 8.42743 8.24609L10.2222 6.46731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1256_82",
    x: -20,
    y: -20,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1256_82"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1256_82",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleRight);
export default __webpack_public_path__ + "static/media/toggle_right.4c07d93c55889c3fd212929df48fa174.svg";
export { ForwardRef as ReactComponent };